export default "__VITE_ASSET__BhqgRure__"